export default __webpack_public_path__ + "static/media/clion.059d43e6.svg";